module.exports = __webpack_public_path__ + "img/giovanni-gagliardi-fvT3t9iOaJI-unsplash.389e273c.png";